function initHeader() {
    let body = $('body');
    let vh, headerHeight, headerNavHeight;
    let header = $('.site-header');
    if (header[0].classList.contains('_init')) return;
    let headerProfileButton = $('.site-header__actions-link--profile');
    let headerCatalogButton = $('.site-header__catalog-button');
    let catalogMenuButton = $('.catalog-menu-btn');
    let headerNavToggle = $('.site-header__nav-toggle');
    let headerMobNavWrap = $('.site-header__mobile-wrap');
    let closeMobCatalog = $('.site-header__catalog-close');
    let headerSearchInput = $('.site-header__search-input');
    let headerSearch = $('.site-header__search');
    let headerMobSearch = $('.site-header__mobile-search');
    let headerMobSearchClose = $('.site-header__search-close');
    let headerChangeCity = $('.site-header__mob-city');
    let cityPopup = $('.city-popup');
    let cityPopupClose = $('.city-popup__close');
    let overlay = $('.overlay');

    let updateElementSize = () => {
        vh = `${window.innerHeight * 0.01}px`
        headerHeight = `${$('.site-header__content').height()}px`;
        headerNavHeight = `${$('.site-header__actions').height()}px`;
        setTimeout(() => {
            body.css({'--header-height': headerHeight, '--header-nav-height': headerNavHeight, '--vh': vh});
        }, 200)
    };
    updateElementSize();
    $(window).resize(() => updateElementSize());


    header.click((e) => {
        if ($(e.target).hasClass('site-header--overlay') || $(e.target).hasClass('site-header__overlay')) {
            header.removeClass('site-header--overlay');
            bodyUnfixPosition();
            $('.site-header__profile').removeClass('site-header__profile--active');
            $('.site-header__catalog').removeClass('site-header__catalog--active');
        }
        if (!$(e.target).parents('.site-header__profile--active').get(0) && $('.site-header__profile--active').get(0) && e.target.closest('.site-header__actions-link--profile')) {
            $('.site-header__profile').removeClass('site-header__profile--active');
            if (!$('.site-header__catalog--active')[0]) {
                bodyUnfixPosition();
                header.removeClass('site-header--overlay');
            }
        } else if (!$(e.target).parents('.site-header__catalog-content').get(0) && $('.site-header__catalog--active').get(0)) {
            $('.site-header__catalog').removeClass('site-header__catalog--active');
            if (!$('.site-header__profile--active')[0]) {
                bodyUnfixPosition();
                header.removeClass('site-header--overlay');
            }
        }
    })

    headerProfileButton.click((e) => {
        if (!$('.site-header__profile').hasClass('site-header__profile--active')) {
            e.stopPropagation();
            $('.site-header__profile').addClass('site-header__profile--active');
            fixSiteHeader();
            if (window.innerWidth <= 767) {
                $('.site-header__catalog').removeClass('site-header__catalog--active');
            }
        }
    });
    headerCatalogButton.click((e) => {
        if (!$('.site-header__catalog').hasClass('site-header__catalog--active')) {
            e.stopPropagation();
            $('.site-header__catalog').addClass('site-header__catalog--active');
            fixSiteHeader();
            if (window.innerWidth <= 767) {
                $('.site-header__profile').removeClass('site-header__profile--active');
            }
        }
    });
    catalogMenuButton.click((e) => {
        if (!$('.site-header__catalog').hasClass('site-header__catalog--active')) {
            e.stopPropagation();
            $('.site-header__catalog').addClass('site-header__catalog--active');
            fixSiteHeader();
            if (window.innerWidth <= 767) {
                $('.site-header__profile').removeClass('site-header__profile--active');
            }
        }
    });
    headerNavToggle.click(() => {
        headerNavToggle.toggleClass('site-header__nav-toggle--active');
        headerMobNavWrap.toggleClass('site-header__mobile-wrap--active');
        if (headerNavToggle.hasClass('site-header__nav-toggle--active')) {
            bodyFixPosition();
        } else {
            bodyUnfixPosition();
        }
    })
    closeMobCatalog.click(() => {
        $('.site-header__catalog').removeClass('site-header__catalog--active');
        header.removeClass('site-header--overlay');
        bodyUnfixPosition();
    })
    headerMobSearch.on('click touchstart', function (e) {
        e.preventDefault();
        headerSearch.addClass('site-header__search--active');
        bodyFixPosition();
    });
    headerMobSearchClose.click(() => {
        headerSearch.removeClass('site-header__search--active');
        bodyUnfixPosition();
    });
    /*headerChangeCity.click(() => {
        cityPopup.addClass('city-popup--active');
        document.body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
        body.addClass('body--ovh');
        overlay.addClass('overlay--open');
    });
    cityPopupClose.click(() => {
        cityPopup.removeClass('city-popup--active');
        document.body.style.paddingRight = `0px`;
        body.removeClass('body--ovh');
        overlay.removeClass('overlay--open');
    });*/
    headerSearchInput.focus(() => headerSearch.addClass('site-header__search--active'));
    headerSearch.click((e) => {
        if ($(e.target).hasClass('site-header__search')) {
            headerSearch.removeClass('site-header__search--active')
        }
    });

    const catalogSearchInput = document.querySelector('.site-header__catalog-search-input');
    const searchInput = document.querySelector('.site-header__search-input');

    searchInput && searchInput.addEventListener('input', (e) => {
        if (window.innerWidth >= 767) return;

        catalogSearchInput.value = e.target.value;
    })

    catalogSearchInput && catalogSearchInput.addEventListener('focus', (e) => {
        if (window.innerWidth > 767) return;

        e.preventDefault();

        $('.site-header__catalog').removeClass('site-header__catalog--active');
        header.removeClass('site-header--overlay');
        bodyUnfixPosition();

        headerSearch.addClass('site-header__search--active');
        bodyFixPosition();

        $('.site-header__search-input').focus();
    })


    function fixSiteHeader() {
        $('.site-header__overlay', header)[0].style.top = $('.site-header')[0].getBoundingClientRect().bottom + 'px'
        header.addClass('site-header--overlay');
        bodyFixPosition();
    }

    function unfixSiteHeader() {
        header.removeClass('site-header--overlay');
        bodyUnfixPosition();
    }

    if (document.querySelector('.site-header__mob-city')) {
        const geoBlock = document.querySelector('.site-header__mob-city');
        const mobTopHeader = document.querySelector('.site-header__top-mobile');
        const nav = document.querySelector('.site-header__nav');

        function changePosition() {
            if (window.innerWidth > 767) {
                //nav.before(geoBlock);
            } else {
                mobTopHeader.prepend(geoBlock);
            }
        }
        changePosition();
        window.addEventListener('resize', changePosition);
    }

    header[0].classList.add('_init');
}
